import React, { Component } from "react";
import Flag from "react-flagkit";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PhoneNumberRoamingStatus } from "../../../../utils/const";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

class SearchResultByPhone extends Component {
  render() {
    const { data } = this.props;
    const {
      country_code,
      country_name,
      country_prefix,
      request_price,
      remaining_balance,
      international_format_number,
      national_format_number,
      valid_number,
      reachable,
      ported,
      ip_warnings,
      roaming,
      current_carrier,
      original_carrier,
      caller_identity
    } = data;

    return (
      <div>
        <div className="d-flex align-items-center">
          <h5 className="mr-3">Phone Information :</h5>
          <Flag country={country_code} />
        </div>
        <div className="pl-3">
          <p>International Number : {international_format_number}</p>
          <p>National Number : {national_format_number}</p>
          <p>Country Name : {country_name}</p>
          <p>Country Prefix : {country_prefix}</p>
          <p>Valid : {valid_number}</p>
          <p>Request Price : {request_price}</p>
          <p>Remaining Balance : {remaining_balance}</p>
          <p>Reachable : {reachable}</p>
          <p>Ported : {ported}</p>
          <p>IP Warnings: {ip_warnings}</p>
          <p>Roaming : {roaming.status}</p>
          {PhoneNumberRoamingStatus.ROAMING === roaming.status ? (
            <div className="pl-3">
              <p>Country Code : {roaming.roaming_country_code}</p>
              <p>Network Code : {roaming.roaming_network_code}</p>
              <p>Network Name : {roaming.roaming_network_name}</p>
            </div>
          ) : (
            <div />
          )}
        </div>
        {current_carrier ? (
          <div>
            <h5>Current Currier :</h5>
            <div className="pl-3">
              <p>Name : {current_carrier.name}</p>
              <p>Country : {current_carrier.country}</p>
              <p>Network Code : {current_carrier.network_code}</p>
              <p>Network Type : {current_carrier.network_type}</p>
            </div>
          </div>
        ) : (
          <div />
        )}
        {original_carrier ? (
          <div>
            <h5>Original Currier :</h5>
            <div className="pl-3">
              <p>Name : {original_carrier.name}</p>
              <p>Country : {original_carrier.country}</p>
              <p>Network Code : {original_carrier.network_code}</p>
              <p>Network Type : {original_carrier.network_type}</p>
            </div>
          </div>
        ) : (
          <div />
        )}
     {caller_identity? (
          <div>
            <h5>Caller identity:</h5>
            <div className="pl-3">
              <p>Name : {caller_identity.first_name}</p>
              <p>Last Name: {caller_identity.last_name}</p>
              <p>Subscription Type : {caller_identity.subscription_type}</p>
              <p>Caller type : {caller_identity.caller_type}</p>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultByPhone);
